import React from 'react';
import { Routes, Route } from 'react-router-dom';
import OtpLogin from '../pages/OtpLogin';
import Aadhar from '../pages/Aadhar';
// import Pan from '../pages/Pan';
import BankDetails from '../pages/Bank';
import { ThemeProvider } from '@emotion/react';
import theme from '../theme/theme';
import { VerificationProvider } from '../VerificationContext';
import Banner from '../components/feature-specific/Banner';
import KYCVerification from '../pages/KYCVerification';
import Welcome from '../pages/Welcome';
import { SnackbarProvider } from '../SnackbarProvider';
import ProtectedRoute from '../ProtectedRoute';
import Tnc from '../pages/Tnc';
import Summary from '../pages/Summary';
import Finish from '../pages/Finish';

function App() {
  return (
    // <VerificationProvider>
      <div className="App">
        <ThemeProvider theme={theme}>
          <SnackbarProvider>
            <Routes>
              <Route path ='/' element={<Welcome/>}/>
              <Route path = '/summary' element={<Summary/>}/>
              <Route path ='/otp-verify' element={<OtpLogin/>}/>
              <Route path="/terms-and-conditions" element={<Tnc />} />
              <Route path='/finish' element = {<Finish/>}/>
              <Route
              path='/kyc-verify'
              element={
                <ProtectedRoute>
                  <KYCVerification />
                </ProtectedRoute>
              }
              />
            </Routes>
          </SnackbarProvider>
        </ThemeProvider>
      </div>
    // </VerificationProvider>
  );
}

export default App;
